import { render, staticRenderFns } from "./DropdownHeaderSites.vue?vue&type=template&id=acdaa8c2"
import script from "./DropdownHeaderSites.vue?vue&type=script&lang=js"
export * from "./DropdownHeaderSites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports